<script>
  let data = $state([
    { x: 180, y: 30, r: 5, fill: 'orange' },
    { x: 100, y: 40, r: 25, fill: 'red' },
    { x: 170, y: 160, r: 50, fill: 'cyan' },
    { x: 120, y: 220, r: 2, fill: 'yellow' },
    { x: 30, y: 100, r: 10, fill: 'fuchsia' }
  ]);

  // I have added a setTimeout function which will update the data

  setTimeout(() => {
    data = [
      { x: 40, y: 70, r: 5, fill: 'red' },
      { x: 100, y: 210, r: 25, fill: 'orange' },
      { x: 120, y: 100, r: 50, fill: 'blue' },
      { x: 350, y: 220, r: 2, fill: 'red' },
      { x: 230, y: 190, r: 10, fill: 'white' }
    ];
  }, 2000);
</script>

<div>
  <svg viewBox="0 0 600 300">
    {#each data as d}
      <circle cx={d.x} cy={d.y} r={d.r} fill={d.fill} />
    {/each}
  </svg>
</div>

<style>
  /* The circles will transition to their new state using css. */
  circle {
    transition: all 1s ease;
  }
</style>
